module.exports = __webpack_public_path__ + "img/favicon.3a34b508.png";